import React, { useEffect, useState } from "react";
import styled from "styled-components";
import IconMen from '../../../assets/images/icon-men.svg'
import IconWomen from '../../../assets/images/icon-women.svg'

const Container = styled.div`
    width: 100%;
    margin-bottom: 16px;

    .label {
        color: #2A2A2A;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
        margin-bottom: 16px;
    }

    .container-radio {
        display: flex;
        gap: 16px;
    }
`;

const RadioBox = styled.div`
    width: 100%;
    height: 52px;
    border-radius: 13px;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 14px 0px #00266F11;
    padding: 0px 16px;
    color: #505050;
    font-size: 15px;
    font-weight: 400;
    line-height: 22.43px;
    text-align: left;
    cursor: pointer;

    &.active {
        /* height: 50px; */
        /* border: 2px solid #FBE250 */
    }

    .circle {
        width: 20px;
        min-width: 20px;
        height: 20px;
        margin-left: 1px;
        margin-right: 12px;
        border-radius: 50%;
        border: 1px solid #505050;

        &.active {
            width: 13px;
            min-width: 13px;
            height: 13px;
            margin-left: 0px;
            margin-right: 12px;
            border: 5px solid #FBE250
        }
    }

    .icon-gender {
        margin-right: 8px;
    }

    &.disable {
        cursor: default;
    }
`;

function GenderComponent({
    label,
    value,
    disable,
    labelError,
    isError,
    styleContainer,
    classContainer,
    onSelect,
}) {
    const valueMen = "men";
    const valueWomen = "women";
    const [gender, setGender] = useState("");

    useEffect(() => {
        if (value) {
            const _gender = value;
            setGender(_gender);
        }
    }, [value])

    function handleSelect(param) {
        if (disable) return
        setGender(param)
        onSelect && onSelect(param)
    }

    return (
        <Container className={`${classContainer}`} style={{ ...styleContainer }}>
            {label && <div className="label">{label}</div>}
            <div className="container-radio">
                <RadioBox className={`vertical-center ${disable ? "disable" : "normal"}  ${gender === valueMen ? "active" : ""}`}
                    onClick={() => { handleSelect(valueMen) }}>
                    <div className={`circle ${gender === valueMen ? "active" : ""}`}></div>
                    <img alt="img" className="icon-gender" src={IconMen} />
                    <div>ชาย</div>
                </RadioBox>
                <RadioBox className={`vertical-center ${disable ? "disable" : "normal"}  ${gender === valueWomen ? "active" : ""}`}
                    onClick={() => { handleSelect(valueWomen) }}>
                    <div className={`circle ${gender === valueWomen ? "active" : ""}`}></div>
                    <img alt="img" className="icon-gender" src={IconWomen} />
                    <div>หญิง</div>
                </RadioBox>
            </div>
        </Container>
    )
}

export default GenderComponent;